export default {
  multiple: 'Drag and drop, or select files',
  single: 'Drag and drop, or select file',
};
